import React from "react";
import { useSelector } from "react-redux";
import { ChartBlock } from "../../../../components/charts/ChartBlock/ChartBlock";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

const PredictionChart = () => {
  const predictionChart = useSelector((state) => state.totalRevenueSales.predictionChart);
  const isPredictionLoading = useSelector((state) => state.totalRevenueSales.isPredictionLoading);
  return isPredictionLoading ? (
    <LoadingAnimation text="Loading prediction..." />
  ) : (
    <ChartBlock
      chart={predictionChart}
      chartId="total-revenue-prediction"
      enableTableView
      enableExportPng
      enableExportExcel
      fileName="prediction-chart"
    />
  );
};

export default PredictionChart;
